import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { streetTypesRoutes } from './street-types.routing'
import { UpdateStreetTypeComponent } from './update-street-type/update-street-type.component'
import { CreateStreetTypeComponent } from './create-street-type/create-street-type.component'
import { StreetTypesComponent } from './street-types.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    StreetTypesComponent,
    CreateStreetTypeComponent,
    UpdateStreetTypeComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(streetTypesRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    StreetTypesComponent,
    CreateStreetTypeComponent,
    UpdateStreetTypeComponent,
  ],
})
export class StreetTypesModule {}
